@use '../@shared/global' as *;
@use '../@shared/card.mixin' as *;
@use '../@shared/mixins' as *;
@use '../tooltip/style.scss' as *;

@layer kol-component {
	@include kol-card;
}
